import { render, staticRenderFns } from "./ExtraHeaders.vue?vue&type=template&id=19f2756b&"
import script from "./ExtraHeaders.vue?vue&type=script&lang=ts&"
export * from "./ExtraHeaders.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraHeaders.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports